












import {Component, Emit, Prop, Vue} from "vue-property-decorator";
import {Criteria} from "@/types";
import FilterChip from '@/components/FilterChip.vue'
import {Criterion} from "@dynamoit/shared/generated/globalTypes";

@Component({
    components: {FilterChip}
})
export default class TableFilter extends Vue {

    @Prop({required: true})
    public value!: Criteria

    private get notEmpty() {
        return Object.values(this.value).length > 0
    }

    @Emit('input')
    private onClear() {
        return {}
    }

    @Emit('input')
    private onDeleteFilter(criterion: Criterion): Criteria {
        return Object.values(this.value)
            .filter(_ => _.property !== criterion.property)
            .reduce((acc, val) => ({
                ...acc,
                [val.property]: val
            }), {})
    }

    @Emit('input')
    private onModifyFilter(criterion: Criterion): Criteria {
        return {
            ...this.value,
            [criterion.property]: criterion
        }
    }

}
